module.exports = __webpack_public_path__ + "img/down-sx2.df518abe.png";